/*
 * @Author: Victor
 * @Date: 2024-02-19 09:43:47
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-25 10:40:08
 * @Description: 
 */
// 颜色配置数据
export const colors = [
    '#FF8C22',
    '#914FF3',
    '#FF5140',
    '#F9CF62',
    '#22DCA2',
    '#B27B48',
    '#127DEF',
    '#E240D3',
    // '#3BBEFF',
    // '#38455F',
];
// 规则数据
export const cryptosRulesData = [
    {
        content1: 'GameCryptos.CryptosRule1',
        constent2: '',
        img: null,
    }
];
// 赔率、中奖概率等配置数据
export const configs = [
    {
        mutiplier: 60,
        pair: 5,
        pair2: 0,
        chance: 0.0244
    },
    {
        mutiplier: 7,
        pair: 4,
        pair2: 0,
        chance: 0.8544
    },
    {
        mutiplier: 6,
        pair: 3,
        pair2: 2,
        chance: 1.7089
    },
    {
        mutiplier: 3.75,
        pair: 3,
        pair2: 0,
        chance: 10.253
    },
    {
        mutiplier: 2.4,
        pair: 2,
        pair2: 2,
        chance: 15.38
    },
    {
        mutiplier: 0.1,
        pair: 2,
        pair2: 0,
        chance: 51.269
    },
    {
        mutiplier: 0,
        pair: 0,
        pair2: 0,
        chance: 20.507
    },
];
